import React from "react";
import { FaSpinner } from "react-icons/fa";
import { Field, reduxForm } from "redux-form";
import "./../NetworkButtonModal.scss";

const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <React.Fragment>
    <label className="usa-sr-only" htmlFor="search-field-big">
      {label}
    </label>
    <input
      id="search-field-big"
      className={error && touched ? "error usa-input" : "usa-input"}
      {...input}
      placeholder={label}
      type={type}
    />
    {touched && error && <div className="input-error">{error}</div>}
  </React.Fragment>
);

const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = "This field is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,7}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  return errors;
};

const NetworkModalFirstPage = (props) => {
  const { handleSubmit, submitting, pristine, onChange, currentUser, isSubmitting } = props;
  return (
    <div className="network-modal-first-page">
      <h3>Invite a new member</h3>
      <p className="modal-body-text">
        Want to invite a new member to join{" "}
        <span className="bold-text">{currentUser.legal_bussiness_name || "N/A"}</span>? Enter an email address below and
        FLAG will email an invitation.
      </p>
      <form onSubmit={handleSubmit} className="usa-search usa-search-big">
        <div role="search">
          <Field name="email" type="search" component={renderField} label="Email Address" onChange={onChange} />
          <button className="usa-button modal-submit-btn" type="submit" disabled={pristine || submitting}>
            <span className="usa-search__submit-text">
              Submit {isSubmitting ? <FaSpinner className="icon-spin" /> : null}
            </span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default reduxForm({
  form: "networkModalFirstPage",
  validate,
})(NetworkModalFirstPage);
